import React, { useState, useEffect, useCallback } from "react";
import { RootRouteProps } from "routers/types/stack";
import { useRoute } from "@react-navigation/native";

import { Platform, View } from "react-native";
import { Text, Toast, CodeInput } from "components";
import EntryScreensForm from "./EntryScreensForm";
import TimerSection from "./TimerSection";

import RNOtpVerify from "react-native-otp-verify";

import { strings, patterns } from "assets/constants";
import css from "styles";

import { useInsertMobile, useVerifyCode } from "clients/apis";
import { useRecoilValue } from "recoil";
import RouteParamsAtom from "stores/recoil/routeParamsAtom";

export default function VerificationCode() {
  // const { mobile, fcm_token, hash_code } =
  //   useRoute<RootRouteProps<"verify_code">>().params;

  const routeParams = useRecoilValue(RouteParamsAtom);

  const insertMobileMut = useInsertMobile();
  const verifyCodeMut = useVerifyCode();

  const [securityCode, setSecurityCode] = useState("");

  const _onSubmit = useCallback(() => {
    if (securityCode?.length < 5) {
      Toast.error({ message: strings?.fill_security_code });
      return;
    }

    if (!securityCode.match(patterns.number)) {
      Toast.error({ message: strings?.invalid_security_code });
      return;
    }

    const postData: VerifyCodeReqT = {
      mobile: routeParams?.mobile,
      otp: securityCode,
      fcm_token: routeParams?.fcm_token,
    };

    verifyCodeMut.mutate(postData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [securityCode, routeParams?.mobile]);

  const _onResendCode = () =>
    insertMobileMut.mutate({
      mobile: routeParams?.mobile,
      hash_code: routeParams?.hash_code,
    });

  useEffect(() => {
    if (Platform.OS === "android") {
      RNOtpVerify.startOtpListener((msg) => {
        setTimeout(
          () =>
            msg &&
            setSecurityCode(msg?.split("\n")?.[1]?.match(/\d+/g)?.[0] ?? ""),
          1000
        );
      });
    }

    return () => Platform.OS === "android" && RNOtpVerify.removeListener();
  }, []);

  useEffect(() => {
    securityCode?.length === 5 &&
      securityCode.match(patterns.number) &&
      _onSubmit();
  }, [securityCode, _onSubmit]);

  return (
    <EntryScreensForm
      submit={_onSubmit}
      submitLabel={strings.confirm}
      submitLoading={verifyCodeMut?.isLoading}
    >
      <Text weight="bold" align="center">
        {strings.code_was_send_to(routeParams?.mobile ?? "")}
      </Text>
      <View style={{ width: 210, marginVertical: 30, ...css.selfCenter }}>
        <CodeInput code={securityCode} getValue={setSecurityCode} />
      </View>

      <TimerSection getCodeAgain={_onResendCode} />
      <View style={{ height: 20 }} />
    </EntryScreensForm>
  );
}
